import React, { useState } from 'react'
import { ZoomInIcon } from '@heroicons/react/solid'

/** lib */
import IngredientsDropdown from '../../components/UI/IngredientsDropdown'
import { IMG_URL, PLACEHOLDER_IMG } from '../../constants/ApiConfiguration'

export default function RecipeStep({ step, ingredientList = [] }) {
  const [showIndgredients, setShowIndgredients] = useState(false)

  // const stepImage = (step?.image) ? `${IMG_URL}/${step?.image}` : PLACEHOLDER_IMG
  
  // const displayFormat = (value) => { 
  //   return value.split(':').map(i => i?.length < 2 ? '0' + i : i).join(':')
  // } 

  const stepIngredients = ingredientList?.filter(i => step?.ingredients?.includes(i?.recipe_ingredient_id))

  return (
    <div className="border-t border-an_orange-darker1 pb-4">
        <div className="flex items-center ">
          <span className="block rounded-full m-2 text-white bg-an_orange-darker1 px-2">{step?.step_order}</span>
          <label className="lowercase pb-1 text-an_green-dark pt-1">{step?.name ?? step?.title ?? `step ${step?.step_order}`}</label>
        </div>

        <div className="flex">
          <p className="pl-4 py-4 whitespace-pre-wrap text-base font-light">
            {step?.description}
          </p>
        </div>
     
        {
         stepIngredients?.length > 0 &&
            <div className="flex cursor-pointer" onClick={() => setShowIndgredients(!showIndgredients)}>
              <ZoomInIcon className="w-6 h-6 text-an_green-dark mt-1 flex-shrink-0" />
              <div className="flex flex-wrap"> 
                { 
                  stepIngredients.map((i) => 
                      <span key={i.ingredient_id} className="text-an_white bg-an_green-dark rounded-full text-[12px] p-1 px-2 m-1">
                        {i?.quantity} {i?.measurement} {i?.treatment} {i?.ingredient?.name} {i?.ingredient?.name_ext && ', ' + i?.ingredient?.name_ext}
                      </span> 
                  )
                }
              </div>
            </div>
        }

        {
          showIndgredients && <IngredientsDropdown ingredients={stepIngredients} show={true} showForm={false} closeCallback={() => setShowIndgredients(false)} />
        }
    </div>
  ) 
}